enum ModuleTypeEnum {
  DualPaneLibrary = "library",
  CustomComponent = "custom",
}

export default ModuleTypeEnum;
